const classes = {
  section: {
    paddingBottom: '4rem',
    paddingLeft: '1.25rem',
    paddingRight: '1.25rem'
  },
  gridBox: {
    display: 'grid',
    gap: 2
  },
  cardBox: {
    display: 'flex',
    background: '#fff',
    marginBottom: '5px',
    flexDirection: 'column' as const,
    '&:hover': {
      cursor: 'pointer',
      transform: 'scale(1.03)',
      transition: 'transform 200ms'
    }
  },
  typeH4: {
    fontWeight: 400,
    height: '50px'
  }
}

export default classes
